import * as actions from './action';

const initialState = {
  imagesEurofours: null,
};

export default (state = initialState, {type, payload}) => {
  switch (type) {
    case actions.IMAGES_GET_EUROFOURS_SUCCESS:
      return {
        ...state,
        imagesEurofours: payload,
      };
    case actions.IMAGES_DELETE_EUROFOURS_SUCCESS:
      return {
        ...state,
        imagesEurofours: payload,
      };
    case actions.IMAGE_SEND_EUROFOURS_SUCCESS:
      return {
        ...state,
        imagesEurofours: payload,
      };
    default:
      return state;
  }
};
